/* eslint-disable no-underscore-dangle */
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import Meeting from '@/models/meeting';
import { reaction } from '@/models';
import { useTimeout } from 'ahooks';
export enum HandUpStatus {
  on = 1,
  off = 2,
}
interface HandupEmoJProps {
  meeting?: Meeting;
  style?: any;
  onClick?: any;
}
const HandupEmoJ: React.FC<HandupEmoJProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { style, onClick } = props;
    const { formatMessage } = useIntl();
    const handupSetting = reaction?.handupSetting;
    const [url, setUrl] = useState<string>();
    useEffect(() => {
      setUrl(handupSetting?.handUpAnimWebp);
    }, []);
    useTimeout(() => {
      setUrl(handupSetting.handUpStaticWebp);
    }, handupSetting?.handUpAnimWebpDuration);

    return <img src={url} onClick={onClick} className={s.icon} style={style} />;
  })
);
export default HandupEmoJ;
